import { get } from 'lodash'

import { RegulationDTO } from 'interfaces/regulations/regulation'

export const getRegulationNameByCode = (regulationCode: string, regulationsList: RegulationDTO[]) => {
  const currentRegulation = regulationsList.find(({ code }) => code === regulationCode)

  return get(currentRegulation, 'name')
}
